import React, { Fragment } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router-dom"
import L from "leaflet"
import { PersistGate } from "redux-persist/integration/react"
import i18next from "i18next"
import { Provider } from "react-redux"
import { ToastContainer } from "react-toastify"
import { initReactI18next } from "react-i18next"

import { setMoment } from "utils/moment"
import { store, persistor } from "@redux"
import router from "routes/index.routes"
import icon from "leaflet/dist/images/marker-icon.png"
import iconShadow from "leaflet/dist/images/marker-shadow.png"
import { addIframeChangeThemeListener, setSiteThemeColor } from "utils"

import fa from "./locales/fa/translation.json"
import en from "./locales/en/translation.json"

import "./index.scss"

i18next
  .use(initReactI18next)
  .init({
    debug: false,
    lng: "fa",
    fallbackLng: "fa",
    resources: {
      fa: { translation: fa },
      en: { translation: en }
    }
  })

const defaultLanguage =
  localStorage.getItem("defaultLanguage") || "fa"

i18next.changeLanguage(defaultLanguage)

i18next.on("languageChanged", (lng) => {
  const fontFamilyLanguageMap = {
    "en": "sans-serif",
    "fa": "yekanX",
    "ar": "yekanX"
  }

  // change website direction
  document.body.style.direction =
    i18next.dir(lng)

  // change website font family
  document.body.style.fontFamily =
    fontFamilyLanguageMap[lng]

  // set time calender
  setMoment(lng)
})

const DefaultIcon = L.icon({ iconUrl: icon, shadowUrl: iconShadow })

L.Marker.prototype.options.icon = DefaultIcon

addIframeChangeThemeListener()

setSiteThemeColor()

const App = () => (
  <Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>

    <ToastContainer rtl />
  </Fragment>
)

const root = createRoot(
  document.getElementById("root")
)

root.render(<App />)